import { useId } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Images, ArrowSquareOut } from '@phosphor-icons/react';
import ComplaintAttachmentPreview from './ComplaintAttachmentPreview';
import { getMediaUrl } from '../../utils/uploadService';
import '../ComplaintDetailsModal.css';
import './ComplaintEvidenceDialog.css';

const ComplaintEvidenceDialog = ({ show, onHide, title, complaintNumber, attachments = [] }) => {
    const titleId = useId();
    const files = (Array.isArray(attachments) ? attachments : []).filter((file) => /^(https?:\/\/|\/)/i.test(getMediaUrl(file)));
    return (
        <Modal show={show} onHide={onHide} centered scrollable size="lg" className="evidence-gallery-modal" aria-labelledby={titleId}>
            <Modal.Header closeButton>
                <span className="evidence-gallery-emblem"><Images size={26} weight="duotone" aria-hidden="true" /></span>
                <div><span className="evidence-gallery-eyebrow">{complaintNumber || 'Complaint record'}</span><Modal.Title id={titleId}>{title}</Modal.Title></div>
            </Modal.Header>
            <Modal.Body>
                <div className="evidence-gallery-toolbar"><strong>{files.length} attachment{files.length === 1 ? '' : 's'}</strong><span>Click a preview to open the full file <ArrowSquareOut size={14} aria-hidden="true" /></span></div>
                {files.length ? <div className="complaint-attachments-grid">{files.map((media, index) => <ComplaintAttachmentPreview key={`${getMediaUrl(media)}-${index}`} media={media} index={index} />)}</div> : <p className="evidence-gallery-empty">No attachments available.</p>}
            </Modal.Body>
            <Modal.Footer><span>Images, documents &amp; media</span><Button variant="success" onClick={onHide}>Close</Button></Modal.Footer>
        </Modal>
    );
};

export default ComplaintEvidenceDialog;
